<template>
  <div></div>
</template>

<script>
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const appModule = namespace('app')

@Component()
export default class AccessMixin extends Vue {
  @appModule.State('userProfile') stateUserProfile

  created() {
    console.log('stateUserProfile', this.stateUserProfile)
  }

  @Watch('stateUserProfile', { immediate: true })
  check() {
    if (this.stateUserProfile && this.stateUserProfile.role !== 'superadmin') {
      this.$router.push({ name: 'HomePage' })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/lib/mixins/access.vue